module.exports = __webpack_public_path__ + "static/img/banner-product-01.2b7ecfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-product-01.jpg
// module id = COYu
// module chunks = 99